import { Outlet } from "react-router-dom";
import AppHeader from "./AppHeader";
import BottomTabBar from "./BottomTabBar";

export default function AppLayout() {
  return (
    <div className="min-h-screen bg-background-100">
      <AppHeader />
      <main className="mx-auto max-w-[480px] px-5 pb-[92px] pt-[76px]">
        <Outlet />
      </main>
      <BottomTabBar />
    </div>
  );
}